import { fetchCsrfToken } from "api/csrfToken";
import { setCsrfToken } from "utils/csrf";
import { getI18nTextIfExists } from "utils/i18n";

import { EntitleError } from "./entitleError";
import SessionExpiredError from "./sessionExpiredError";

const MAX_RETRIES_ATTEMPTS = 3;

export default class InvalidCsrfError extends EntitleError {
  private static attempt = 0;

  constructor() {
    super(
      getI18nTextIfExists("errors.invalidCsrf.message") ?? "",
      getI18nTextIfExists("errors.invalidCsrf.title") ?? "",
    );
    if (InvalidCsrfError.attempt++ < MAX_RETRIES_ATTEMPTS) {
      void this.reloadCsrfToken();
    } else {
      throw new SessionExpiredError();
    }
  }

  async reloadCsrfToken() {
    const token = await fetchCsrfToken();
    setCsrfToken(token);
  }
}
